module.exports = __webpack_public_path__ + "img/courier-usps.319cecbe.svg";